import { Map, List } from 'immutable';

const ResourceIdentity = new Map();
function resource(state = ResourceIdentity, action) {
  let newState;
  switch (action.type) {
    case '@@reduxReactor/READ_START': {
      const { id } = action.data;

      if (!id) {
        return state;
      }

      const ids = List.isList(id) ? id : new List([id]);

      newState = ids.reduce(
        (acc, idVal) => ({
          ...acc,
          [idVal]: { status: 'pending' },
        }),
        {}
      );

      return state.merge(newState);
    }

    case '@@reduxReactor/READ_FINISH': {
      const resourceName = action.data.resource;
      const newData = action.data.response[resourceName];
      return state.merge(newData);
    }

    default:
      return state;
  }
}

const ResourcesIdentity = new Map();
export default function resources(state = ResourcesIdentity, action) {
  switch (action.type) {
    case '@@reduxReactor/READ_START':
      return state.merge({
        [action.data.resource]: resource(state.get(action.data.resource), action),
      });

    case '@@reduxReactor/READ_FINISH': {
      const newState = Object.keys(action.data.response).reduce(
        (acc, key) => ({
          ...acc,
          [key]: resource(state.get(key), action),
        }),
        {}
      );
      return state.merge(newState);
    }

    case '@@reduxReactor/READ_FAIL':
      return state;

    default:
      return state;
  }
}
